import React from 'react';
import '../styles/Exportacion.css';

const IconRFC = () => ( <svg viewBox="0 0 24 24" width="44" height="44" aria-hidden="true"> <path d="M7 3h7l5 5v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" stroke="currentColor" strokeWidth="1.8" fill="none"/> <path d="M14 3v4a1 1 0 0 0 1 1h4" stroke="currentColor" strokeWidth="1.8" fill="none"/> <path d="M9 11h6M9 15h4" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round"/> </svg> );
const IconOblig = () => ( <svg viewBox="0 0 24 24" width="44" height="44" aria-hidden="true"> <path d="M15 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7l-4-3z" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinejoin="round"/> <path d="m8 11.5 2 2 4-4M8 16.5l2 2 4-4" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/> </svg> );
const IconEFirma = () => ( <svg viewBox="0 0 24 24" width="44" height="44" aria-hidden="true"> <path d="M8 11a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1M12 11v5a1 1 0 0 0 1 1h1M11 7a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 0 1 1h1M16 11.002v.003M16 14.005v-.003" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round"/> <path d="M12 21a9 9 0 1 0-9-9" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round"/> </svg> );
const IconDom = () => ( <svg viewBox="0 0 24 24" width="44" height="44" aria-hidden="true"> <path d="M12 21s7-6.1 7-11.2A7 7 0 1 0 5 9.8C5 14.9 12 21 12 21z" stroke="currentColor" strokeWidth="1.8" fill="none"/> <circle cx="12" cy="9.5" r="2" stroke="currentColor" strokeWidth="1.6" fill="none"/> </svg> );
const IconBuzon = () => ( <svg viewBox="0 0 24 24" width="44" height="44" aria-hidden="true"> <rect x="3" y="6" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="1.8" fill="none"/> <path d="m3 8 9 6 9-6" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round"/> </svg> );
const IconAgente = () => ( <svg viewBox="0 0 24 24" width="44" height="44" aria-hidden="true"> <circle cx="12" cy="7" r="3" stroke="currentColor" strokeWidth="1.8" fill="none"/> <path d="M4 20a8 8 0 0 1 16 0" stroke="currentColor" strokeWidth="1.8" fill="none"/> </svg> );
const IconListado = () => ( <svg viewBox="0 0 24 24" width="44" height="44" aria-hidden="true"> <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round"/> <path d="M22 4 12 14.01l-3-3.01" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/> </svg> );

const pasosConfig = [
  {
    id: 1,
    gridClass: 'fig-step1',
    Icon: IconRFC,
    titulo: <>Estatus <strong>“ACTIVO”</strong> en el RFC.</>,
    linkTexto: 'Verificar si estoy inscrito',
    linkUrl: 'https://wwwmat.sat.gob.mx/aplicacion/operacion/29073/verifica-si-estas-registrado-en-el-rfc'
  },
  { 
    id: 2,
    gridClass: 'fig-step2', 
    Icon: IconOblig,
    titulo: <>Cumplir tus <strong>obligaciones fiscales</strong>.</>,
    linkTexto: 'Consulta tu información fiscal',
    linkUrl: 'https://wwwmat.sat.gob.mx/consultas/login/44083/consulta-tu-informacion-fiscal'
  },
  { 
    id: 3,
    gridClass: 'fig-step3', 
    Icon: IconEFirma,
    titulo: <>Contar con <strong>e.firma vigente</strong>.</>,
    linkTexto: 'Valida tu e.firma',
    linkUrl: 'https://wwwmat.sat.gob.mx/tramites/operacion/19941/valida-la-vigencia-de-tu-e.firma-(antes-firma-electronica)'
  },
  {
    id: 4,
    gridClass: 'fig-step4', 
    Icon: IconDom,
    titulo: <>Domicilio fiscal <strong>“Localizado”</strong>.</>,
  },
  {
    id: 5,
    gridClass: 'fig-step5', 
    Icon: IconBuzon,
    titulo: <>Medios del Buzón <strong>“Validados”</strong>.</>,
  },
  {
    id: 6,
    gridClass: 'fig-step6', 
    Icon: IconAgente,
    titulo: <>Contar con <strong>agente o representante aduanal</strong>.</>,
  },
  {
    id: 7,
    gridClass: 'fig-step7',
    Icon: IconListado,
    titulo: <>No estar en el listado del SAT <strong>(Art. 69, 69-B)</strong>.</>,
  },
];

const Exportacion = () => {
  // Lógica para manejar el clic y mostrar la alerta
  const handleLinkClick = (e, url) => {
    e.preventDefault();
    const confirmar = window.confirm("Estás a punto de abandonar este sitio web para ir al portal del SAT. ¿Deseas continuar?");
    
    if (confirmar) {
      // Definimos el tamaño de la ventana
      const width = 1024;
      const height = 800;
      
      // Cálculo para centrar la ventana en la pantalla del usuario
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      // Cadena de configuración que fuerza la "ventana nueva"
      const features = `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes,noopener,noreferrer`;

      window.open(url, '_blank', features);
    }
  };

  return (
    <section className="expo-fig">
      <h1>Exportación de mercancías</h1>
      <p className="expo-fig__sub">Guía paso a paso para realizar la exportación de mercancías</p>

      <div className="fig-grid">
        {pasosConfig.map((paso) => (
          <div 
            key={paso.id} 
            className={`fig-item ${paso.gridClass}`} 
          >
            <div className="fig-icon"><paso.Icon /></div>
            <p className="fig-text">
              {paso.titulo}
              {paso.linkTexto && (
                <>
                  <br/>
                  <a 
                    className="cta" 
                    href={paso.linkUrl}
                    onClick={(e) => handleLinkClick(e, paso.linkUrl)}
                    // Dejamos target="_blank" por accesibilidad, aunque el onClick lo intercepta
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    {paso.linkTexto}
                  </a>
                </>
              )}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Exportacion;


